import { ChangeEvent } from "react";
import styled from "styled-components";
import { MAIN_THEME } from "styles/colors";

interface Props {
	value: string | number;
	onChange: (value: string | number) => void;
	type?: string;
	placeholder?: string;
	leftContainer?: JSX.Element;
	rightContainer?: JSX.Element;
}

interface InputProps {
	leftContainer?: JSX.Element;
	rightContainer?: JSX.Element;
}

const Container = styled.div`
	height: 60px;
	width: 100%;
	background: ${MAIN_THEME.DARK_BG_TERTIARY};
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	border-radius: 55px;
	display: flex;
	transition: border-color 0.15s ease;

	&:focus-within {
		border-color: ${MAIN_THEME.SECONDARY};
	}


	@media (max-width: 768px) {
		height: 50px;
	}
`;

const InputComponent = styled.input<InputProps>`
	height: 100%;
	width: 100%;
	background: transparent;
	border-radius: 55px;
	border: none;
	color: ${MAIN_THEME.TEXT_PRIMARY};
	font-size: 16px;
	padding-left: ${(props) => (props.leftContainer ? 0 : "24px")};
	padding-right: ${(props) => (props.rightContainer ? 0 : "24px")};
	outline: none;

	::placeholder,
	::-webkit-input-placeholder {
		color: ${MAIN_THEME.TEXT_TERTIARY};
	}
	:-ms-input-placeholder {
		color: ${MAIN_THEME.TEXT_TERTIARY};
	}

	@media (max-width: 768px) {
		font-size: 14px;
	}
`;

const Input = (props: Props): JSX.Element => {
	const { value, onChange, type, placeholder, leftContainer, rightContainer } =
		props;

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const newValue = event.target.value;

		onChange(newValue);
	};

	return (
		<Container>
			{leftContainer}
			<InputComponent
				value={value}
				onChange={handleChange}
				type={type || "text"}
				placeholder={placeholder}
				rightContainer={rightContainer}
				leftContainer={leftContainer}
			/>
			{rightContainer}
		</Container>
	);
};

export default Input;
